import {Injectable, Inject} from 'ng-metadata/core';
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {UserSessionManagerService} from '../../../security/userSessionManager.service';
import {SearchService} from '../../search.service';
import {FavoritesService} from "../../../favorites/favorites.service";
import {BrowseSearchService} from "../../browse/browseSearch.service";
import {SearchFieldsService} from "../../search.fields.service";
import {CollectionGalleryService} from "../../../collectionDiscovery/collectionGallery/collectionGallery.service";

const differenceWith = require('lodash/differenceWith');
const isEqual = require('lodash/isEqual');
const isArray = require('lodash/isArray');


@Injectable()
export class SkipToService {
    private skipLinksObject = {};
    private signedInOnlyLabels = ['favoritesLabels'];
    private withSearchResultsLabels = ['facets', 'mainResults', 'favoritesLabels'];
    private withSimpleSearchLabels = ['advanced-search'];
    private withAdvancedSearchLabels = ['searchBar'];
    private withSortAndSearchLabels = ['searchWithinInput'];

    constructor(private userSessionManagerService: UserSessionManagerService,
                private searchService: SearchService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private favoritesService: FavoritesService,
                private browseSearchService: BrowseSearchService,
                private searchFieldsService: SearchFieldsService,
                private collectionGalleryService: CollectionGalleryService) {
        this.skipLinksObject[STATE_NAMES.SEARCH] = ['mainMenu', 'searchBar', 'advanced-search', 'mainResults', 'facets'];
        this.skipLinksObject[STATE_NAMES.JOURNAL_SEARCH] = ['mainMenu', 'searchBarJournal', 'mainResults'];
        this.skipLinksObject[STATE_NAMES.FAVORITES] = ['mainMenu', 'searchBar', 'advanced-search', 'mainResults', 'favoritesLabels'];
        this.skipLinksObject['account'] = ['mainMenu', 'accountoverview'];
        this.skipLinksObject[STATE_NAMES.CITATION_TRAILS] = ['mainMenu', 'citationTrail', 'mainResults'];
        this.skipLinksObject[STATE_NAMES.CITATION_CHAPTERS] = ['mainMenu', 'mainResults'];
        this.skipLinksObject[STATE_NAMES.CITATION_LINKER] = ['mainMenu', 'citationLinker'];
        this.skipLinksObject[STATE_NAMES.TAGS] = ['mainMenu', 'searchBarTags', 'tags'];
        this.skipLinksObject[STATE_NAMES.NEWSPAPERS] = ['mainMenu', 'searchBar', 'mainResults'];
        this.skipLinksObject[STATE_NAMES.BROWSE_SEARCH] = ['mainMenu', 'searchBar', 'mainResults'];
        this.skipLinksObject[STATE_NAMES.DB_SEARCH] = ['mainMenu', 'searchBarJournal', 'mainResults'];
        this.skipLinksObject[STATE_NAMES.COLLECTION_DISCOVERY] = ['mainMenu', 'searchWithinInput', 'mainCollResults'];
        this.skipLinksObject[STATE_NAMES.ORGANIZATION_LIST] = ['mainMenu', 'searchBarJournal', 'mainResults'];
    }


//different skip links gust/user

    get skipLinks() {
        let skipLinks = this.skipLinksObject[this.$state.current.name];
        if (this.userSessionManagerService.isGuest()) {
            skipLinks = differenceWith(skipLinks, this.signedInOnlyLabels, isEqual);
        }
        if (!this.hasSearchResults()) {
            skipLinks = differenceWith(skipLinks, this.withSearchResultsLabels, isEqual);
        }
        if (this.getAdvancedSearch()) {
            skipLinks = differenceWith(skipLinks, this.withAdvancedSearchLabels, isEqual);
        } else {
            skipLinks = differenceWith(skipLinks, this.withSimpleSearchLabels, isEqual);
        }
        if (this.hasSortAndSearch()) {
            skipLinks = differenceWith(skipLinks, this.withSortAndSearchLabels, isEqual);
        }
        return skipLinks;
    }

//different skip links gust/user - End


    getStateSkipLinksArray() {
        let arr = ['searchBar', 'navigation'];
        this.hasSearchResults() && arr.push('mainResults', 'facets');
        return arr;
    }

    private hasSearchResults(): boolean {
        let items;
        if (this.$state.current.name === STATE_NAMES.FAVORITES) {
            items = this.favoritesService.getItems();
        } else if (this.$state.current.name === STATE_NAMES.BROWSE_SEARCH) {
            items = this.browseSearchService.browseResult;
        } else {
            items = this.searchResults;
        }
        return isArray(items) && items.length > 0;
    }

    private get searchResults() {
        return this.searchService.getResultObject().data;
    }

    // If Advanced search is open
    public getAdvancedSearch() {
        return this.searchFieldsService.advancedSearch;
    }

    // If has gallery lobby
    public hasSortAndSearch() {
        return this.collectionGalleryService.isGalleryLobby;
    }

}

//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/skipTo/skipTo.service.ts